import { CheckboxUI } from '../Interface';
import { useFormikContext } from 'formik';

const OperationUserLinks = ({ disabled }) => {
  const { values, setFieldValue } = useFormikContext();

  const updateUserLink = (userId, isChecked) => {
    const updatedLinks = values?.operationUserLink?.map((link) =>
      link.userId === userId ? { ...link, checked: isChecked } : link
    );
    setFieldValue('operationUserLink', updatedLinks);
  };

  return (
    <div>
      {values?.operationUserLink?.map((userLink) => (
        <div key={userLink.userId}>
          <CheckboxUI
            sx={{ margin: 0, padding: '0.2rem' }}
            disabled={disabled}
            onChange={(e) => updateUserLink(userLink.userId, e.target.checked)}
            checked={userLink.checked || false}
          />
          {userLink.nickName}
        </div>
      ))}
    </div>
  );
};

export default OperationUserLinks;
